module.exports = __webpack_public_path__ + "static/img/12areaA_04.4864fe5.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/animal/12areaA_04.png
// module id = 788
// module chunks = 1